const COMMON = 'Chung';
/** Bốn mục rời ngay dưới Bảng tin (05/10/2026) — xem `DAILY` ở `navigation.tsx`. */
const DAILY = 'Hằng ngày';
const CHANNELS = 'Kênh & Nội dung';
const PRODUCER = 'Producer';
const REVENUE = 'Doanh thu';
const WORK = 'Công việc';
const ANALYSIS = 'Phân tích';
const THUMBNAIL = 'Thumbnail';
const ADMIN = 'Quản trị';
export const SCREENS = [
    { path: '/', label: 'Bảng tin', group: COMMON },
    { path: '/account', label: 'Tài khoản & mật khẩu', group: COMMON },
    { path: '/attendance', label: 'Chấm công', group: DAILY },
    { path: '/work-reports', label: 'Báo cáo công việc cá nhân', group: DAILY },
    { path: '/revenue/entry', label: 'Nhập doanh thu', group: DAILY },
    { path: '/requests', label: 'Phiếu đề xuất & đơn', group: DAILY },
    { path: '/seo', label: 'SEO kênh', group: CHANNELS },
    { path: '/music', label: 'Kho nhạc', group: CHANNELS },
    { path: '/cid', label: 'Quản lý CID', group: CHANNELS },
    { path: '/video-publish', label: 'Đăng video', group: CHANNELS },
    { path: '/video-download', label: 'Tải video', group: CHANNELS },
    { path: '/production', label: 'Tổng hợp sản xuất nhạc', group: PRODUCER },
    { path: '/production/kpi', label: 'Tiến độ hằng ngày', group: PRODUCER },
    { path: '/production/kpi/summary', label: 'Tổng hợp tuần & tháng', group: PRODUCER },
    { path: '/production/done', label: 'Dự án hoàn thành', group: PRODUCER },
    { path: '/revenue/reports/day', label: 'Báo cáo ngày', group: REVENUE },
    { path: '/revenue/reports/week', label: 'Báo cáo tuần', group: REVENUE },
    { path: '/revenue/reports/month', label: 'Báo cáo tháng', group: REVENUE },
    { path: '/channels', label: 'Thông tin kênh', group: REVENUE },
    { path: '/kpi', label: 'KPI', group: WORK },
    { path: '/projects', label: 'Dự án', group: WORK },
    { path: '/work-reports/days', label: 'Tổng hợp theo ngày', group: WORK },
    { path: '/meetings', label: 'Họp tuần', group: WORK },
    { path: '/worklog', label: 'Nhật ký công việc', group: WORK },
    { path: '/market', label: 'Thị trường', group: ANALYSIS },
    { path: '/thumbnail-library', label: 'Upload Kho Thumbnail hằng ngày', group: THUMBNAIL },
    { path: '/thumbnail-download', label: 'Tải thumbnail đối thủ', group: THUMBNAIL },
    { path: '/thumbnail-maker', label: 'Làm thumbnail', group: THUMBNAIL },
    { path: '/thumbnail-quick', label: 'Thumb video ngắn', group: THUMBNAIL },
    { path: '/thumbnail-summary', label: 'Tổng hợp tuần & tháng', group: THUMBNAIL },
    { path: '/competitors', label: 'Nghiên cứu đối thủ', group: ANALYSIS },
    { path: '/office-research', label: 'Phân tích kênh văn phòng', group: ANALYSIS },
    { path: '/vault', label: 'Hệ thống mail', group: ADMIN },
    { path: '/gpm', label: 'Quản lý GPM', group: ADMIN },
    { path: '/channel-ops', label: 'Vận hành kênh', group: ADMIN },
    { path: '/org-chart', label: 'Sơ đồ bộ máy công ty', group: ADMIN },
    { path: '/profiles', label: 'Hồ sơ nhân sự', group: ADMIN },
    { path: '/activity', label: 'Lịch sử truy cập', group: ADMIN },
    { path: '/settings', label: 'Cài đặt', group: ADMIN },
];
const byPath = new Map(SCREENS.map((screen) => [screen.path, screen]));
/**
 * Màn hình của một đường dẫn. Khớp phần ĐẦU và lấy đường dẫn DÀI NHẤT khớp được, nên các màn con
 * (`/seo/week`, `/settings/youtube-keys`) tính vào đúng mục cha của chúng. Đường dẫn lạ trả
 * `undefined` — không ghi gì cả.
 */
export function screenForPath(pathname) {
    const clean = pathname.split('?')[0]?.replace(/\/+$/, '') ?? '';
    if (clean === '')
        return byPath.get('/');
    return SCREENS.filter((screen) => screen.path !== '/' && (clean === screen.path || clean.startsWith(`${screen.path}/`))).sort((a, b) => b.path.length - a.path.length)[0];
}
/** Nhãn của một mã màn hình đã lưu; mã lạ (bản cũ đổi đường dẫn) hiện nguyên mã. */
export function screenLabel(path) {
    return byPath.get(path)?.label ?? path;
}
export function screenGroup(path) {
    return byPath.get(path)?.group ?? COMMON;
}
//# sourceMappingURL=screens.js.map